import logger from "../utils/logger";
export const loadOzonAttributes = async ({
  request,
  accountId,
  limit,
  offset,
  attributesHeadersDisplay,
  attributesSort,
  attributesSearch,
  setOzonAttributes,
  setOzonAttributesTotal
}) => {
  const sortHeader = attributesHeadersDisplay[attributesSort.index] || '';
  const validSortBy = sortHeader === '№' || sortHeader === 'Артикул' ? '' : sortHeader;
  const query = new URLSearchParams({
    limit: String(limit),
    offset: String(offset),
    search: attributesSearch,
    sort_by: validSortBy,
    sort_dir: attributesSort.dir
  });
  const data = await request(`/api/v1/ozon/${accountId}/attributes?${query.toString()}`, {});
  logger.info(`[Attributes] headers: ${data.headers?.length}, rows: ${data.rows?.length}, total: ${data.total}`);
  setOzonAttributes({
    headers: data.headers || [],
    rows: data.rows || []
  });
  setOzonAttributesTotal(data.total || 0);
};
export const loadOzonAssortment = async ({
  request,
  accountId,
  limit,
  offset,
  assortmentHeadersDisplay,
  assortmentSort,
  assortmentSearch,
  setOzonAssortment,
  setOzonAssortmentTotal
}) => {
  const query = new URLSearchParams({
    limit: String(limit),
    offset: String(offset),
    search: assortmentSearch,
    sort_by: assortmentHeadersDisplay[assortmentSort.index] || '',
    sort_dir: assortmentSort.dir
  });
  const data = await request(`/api/v1/ozon/${accountId}/assortment?${query.toString()}`, {});
  setOzonAssortment(data.rows || []);
  setOzonAssortmentTotal(data.total || 0);
};
export const syncOzonData = async ({
  request,
  ozonAccountId,
  setOzonBusy,
  setStatus,
  showStatus,
  loadOzonAttributes,
  loadOzonAssortment,
  attributesPageSize,
  attributesSliceStart,
  assortmentPageSize,
  assortmentSliceStart
}) => {
  if (!ozonAccountId) return;
  setOzonBusy(true);
  setStatus(null);
  showStatus('info', 'Идет полная загрузка данных из OZON. Процесс может занять несколько минут.');
  try {
    const result = await request(`/api/v1/ozon/${ozonAccountId}/sync`, {
      method: 'POST'
    });
    showStatus('success', `OZON выгрузка обновлена: атрибуты ${result.attributes_count}, ассортимент ${result.assortment_count}`);
    await Promise.all([loadOzonAttributes(ozonAccountId, attributesPageSize, attributesSliceStart), loadOzonAssortment(ozonAccountId, assortmentPageSize, assortmentSliceStart)]);
  } catch (error) {
    logger.error(error);
    showStatus('error', 'Не удалось обновить данные OZON.');
  } finally {
    setOzonBusy(false);
  }
};
export const syncOzonFast = async ({
  request,
  ozonAccountId,
  setOzonBusy,
  setStatus,
  showStatus,
  loadOzonAttributes,
  loadOzonAssortment,
  attributesPageSize,
  attributesSliceStart,
  assortmentPageSize,
  assortmentSliceStart
}) => {
  if (!ozonAccountId) return;
  setOzonBusy(true);
  setStatus(null);
  showStatus('info', 'Идет быстрое обновление данных из OZON.');
  try {
    const result = await request(`/api/v1/ozon/${ozonAccountId}/sync-fast`, {
      method: 'POST'
    });
    showStatus('success', `OZON обновлен: атрибуты ${result.attributes_count}, ассортимент ${result.assortment_count}`);
    await Promise.all([loadOzonAttributes(ozonAccountId, attributesPageSize, attributesSliceStart), loadOzonAssortment(ozonAccountId, assortmentPageSize, assortmentSliceStart)]);
  } catch (error) {
    logger.error(error);
    showStatus('error', 'Не удалось быстро обновить данные OZON.');
  } finally {
    setOzonBusy(false);
  }
};
